import { render, staticRenderFns } from "./index.vue?vue&type=template&id=65985bff&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./index.scss?vue&type=style&index=0&id=65985bff&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65985bff",
  null
  
)

export default component.exports